/**
 * Application environment configuration
 * This centralizes all environment-specific configuration in one place
 */

const common = {
  TIMEOUT: 10000,
};

const ENV = {
  development: {
    API_URL: process.env.REACT_APP_API_BASE_URL || 'http://192.168.1.2:5000/api',
    ENABLE_LOGS: true,
    ...common,
  },
  production: {
    API_URL: process.env.REACT_APP_API_BASE_URL || '/api',
    ENABLE_LOGS: false,
    TIMEOUT: 30000,
  },
  test: {
    API_URL: 'http://localhost:3001/api',
    ENABLE_LOGS: false,
    ...common,
  },
  staging: {
    API_URL: process.env.REACT_APP_API_BASE_URL || '/api',
    ENABLE_LOGS: true,
    ...common,
  },
};

// Default to 'development' if NODE_ENV is not set
const currentEnv = process.env.NODE_ENV || 'development';

export default ENV[currentEnv];

